import React from 'react';

export default function FilePreview() {
    return (
        <div>
            <p>FilePreview</p>
        </div>
    )
}